import React from 'react'
import Select from 'react-select'
import { CustomInput } from 'reactstrap'
import Switch from 'rc-switch'
import 'rc-switch/assets/index.css'

import DatePicker, { registerLocale } from 'react-datepicker'
import vi from 'date-fns/locale/vi'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('vi', vi)

export class FormikReactSelect extends React.Component {
  handleChange = (value) => {
    this.props.onChange(this.props.name, value)
  }
  handleBlur = () => {
    this.props.onBlur(this.props.name, true)
  }

  render() {
    const customStyles = {
      control: (base) => ({
        ...base,
        height: 45,
        minHeight: 45,
      }),
    }
    return (
      <Select
        styles={customStyles}
        className={`react-select ${this.props.className}`}
        classNamePrefix="react-select"
        options={this.props.options}
        isDisabled={this.props.isDisabled}
        isLoading={this.props.isLoading}
        isMulti={this.props.isMulti}
        isSearchable={this.props.isSearchable}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        value={this.props.value}
        placeholder={this.props.placeholder}
      />
    )
  }
}

export class FormikCustomCheckboxGroup extends React.Component {
  handleChange = (val) => {
    let valueArray = [...this.props.value] || []
    if (!valueArray.includes(val)) {
      valueArray.push(val)
    } else {
      valueArray.splice(valueArray.indexOf(val), 1)
    }
    this.props.onChange(this.props.name, valueArray)
  }

  handleBlur = () => {
    this.props.onBlur(this.props.name, true)
  }

  render() {
    const { name, value, options, inline = false } = this.props
    return (
      <React.Fragment>
        {options.map((child, index) => {
          return (
            <CustomInput
              key={`${name}_${child.value}_${index}`}
              type="checkbox"
              id={`${name}_${child.value}_${index}`}
              name={child.name}
              label={child.label}
              onChange={() => this.handleChange(child.value)}
              onBlur={this.handleBlur}
              checked={value.includes(child.value)}
              disabled={child.disabled}
              inline={inline}
            />
          )
        })}
      </React.Fragment>
    )
  }
}

export const FormikCustomCheckbox = (props) => {
  const handleChange = (event) => {
    props.onChange(props.name, !props.value)
  }
  const handleBlur = () => {
    props.onBlur(props.name, true)
  }
  return (
    <CustomInput
      type="checkbox"
      id={props.name}
      name={props.name}
      label={props.label}
      onChange={handleChange}
      onBlur={handleBlur}
      checked={props.value}
      disabled={props.disabled}
      inline
    />
  )
}

export class FormikCustomRadioGroup extends React.Component {
  handleChange = (val) => {
    this.props.onChange(this.props.name, val)
  }

  handleBlur = () => {
    this.props.onBlur(this.props.name, true)
  }

  render() {
    const { name, value, options, inline = false } = this.props
    return (
      <React.Fragment>
        {options.map((child, index) => {
          return (
            <CustomInput
              key={`${name}_${child.value}_${index}`}
              type="radio"
              id={`${name}_${child.value}_${index}`}
              name={child.name}
              label={child.label}
              onChange={() => this.handleChange(child.value)}
              onBlur={this.handleBlur}
              checked={value === child.value}
              disabled={child.disabled}
              inline={inline}
            />
          )
        })}
      </React.Fragment>
    )
  }
}

export class FormikSwitch extends React.Component {
  handleChange = (val) => {
    this.props.onBlur(this.props.name, true)
    this.props.onChange(this.props.name, val)
  }

  render() {
    const { name, value, className } = this.props
    return <Switch id={name} name={name} className={className} checked={value} onChange={this.handleChange} />
  }
}

export class FormikDatePicker extends React.Component {
  handleChange = (val) => {
    this.props.onChange(this.props.name, val)
  }
  handleBlur = (val) => {
    this.props.onBlur(this.props.name, true)
  }

  render() {
    const { name, value, className, placeholder } = this.props
    return (
      <DatePicker
        locale="vi"
        id={name}
        name={name}
        className={className}
        dateFormat="dd/MM/yyyy"
        selected={value ? value : null}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        placeholderText={placeholder}
      />
    )
  }
}
